import React from 'react';

const TermPage = () => {
    return (
        <div className="legal-container">
            <div className="glass-card">
                <h1 className="section-title">Terms & Conditions</h1>
                <span className="last-updated">Last updated: April 26, 2026</span>

                <div className="content-block">
                    <p>Welcome to Depth Live Wallpaper Pro. Please read these terms and conditions carefully before using our application.</p>

                    <h2>1. Agreement to Terms</h2>
                    <p>By downloading or using the Depth Live Wallpaper Pro application (the "Service"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, do not use the Service.</p>

                    <h2>2. Interpretation and Definitions</h2>
                    <p><strong>Application:</strong> Refers to Depth Live Wallpaper Pro, the software provided by the Company.</p>
                    <p><strong>Company:</strong> Refers to Depth Studio (referred to as either "the Company", "We", "Us" or "Our").</p>
                    <p><strong>Service:</strong> Refers to the Application and its functionalities.</p>
                    <p><strong>You:</strong> Refers to the individual accessing or using the Service.</p>

                    <h2>3. Use of the Service</h2>
                    <p>Depth Live Wallpaper Pro provides premium dynamic wallpapers. You are granted a limited, non-exclusive, non-transferable, revocable license to use the Service for personal, non-commercial purposes on your mobile device.</p>
                    <p>You agree not to modify, decompile, or reverse engineer the Application or any part thereof.</p>

                    <h2>4. Intellectual Property</h2>
                    <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Depth Studio and its licensors. All wallpaper assets, shaders, and engine code are protected by copyright and trademark laws.</p>

                    <h2>5. User Responsibilities</h2>
                    <p>You represent that you are at least 13 years of age. Some features may require a device with specific hardware capabilities (e.g., gyroscopes or depth sensors).</p>

                    <h2>6. Limitation of Liability</h2>
                    <p>In no event shall the Company be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data, or business interruption) arising out of or in any way related to the use of or inability to use the Service.</p>

                    <h2>7. "AS IS" Disclaimer</h2>
                    <p>The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. The Company does not warrant that the Service will meet your requirements or be error-free.</p>

                    <h2>8. Changes to Terms</h2>
                    <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. Significant changes will be communicated through the Application or via the store listing.</p>

                    <h2>9. Contact Us</h2>
                    <p>If you have any questions about these Terms and Conditions, you can contact us:</p>
                    <ul>
                        <li>By email: support@depthstudio.live</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TermPage;